export const tipProps = {
  //提示框显示隐藏
  visible: {
    type: Boolean,
    default: true
  },
  //提示框主文本内容，slot：content可替换标签，  长文本内容 slot:longText
  text: {
    type: String,
    default: ''
  },
  //提示框类型 text: 文本提示、warning: 警告提示（无底色）、warningBackGround: 警告提示（含底色）、error: 错误提示（无底色）、errorBackGround: 错误提示（含底色）
  type: {
    type: String,
    default: 'warning'
  },
  //是否可关闭提示
  hasClose: {
    type: Boolean,
    default: true
  },
  //自定义关闭方法
  customClose: {
    type: Function,
    default: ''
  }
}
